import { BaseDataModel } from "@domain/BaseDataModel";

export class BarcodeType extends BaseDataModel {
	name: string = "";
}
